module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-yes",
    class: {
      active: _vm.activeValue == 'yes'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.input('yes')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-no",
    class: {
      active: _vm.activeValue == 'no'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.input('no')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.activeValue == 'n/a'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.input('n/a')
      }
    }
  }, [_vm._v("N/A")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6688916","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YesNoNaButtons.vue
// module id = 308
// module chunks = 0